module.exports = __webpack_public_path__ + "static/media/stilly13.ad7fc065.JPG";